import { render, staticRenderFns } from "./form-address.vue?vue&type=template&id=1e74c697&"
import script from "./form-address.vue?vue&type=script&lang=js&"
export * from "./form-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports